import {
    Document,
    Page,
    View,
    StyleSheet,
    Text,
    Font,
} from "@react-pdf/renderer";
import srcArial from "../../../assets/custom/font/arial/arial.ttf";
import srcTimes from "../../../assets/custom/font/times/times.ttf";
import srcArialBold from "../../../assets/custom/font/arial/ARIBL0.ttf";
import srcTimesBold from "../../../assets/custom/font/times/timesbd.ttf";
import { useCallback, useEffect, useMemo, useState } from "react";
import TransaksiService from "../../../services/transaksi/TransaksiService";
import UserService from "../../../services/user/UserService";
// import MasterService from "../../../services/master/MasterService";
import { formatDateStringDateFirst, formatRupiah, getNamaUPTBaru, numberToWords } from "../../../utilities/Utils";
import TarifPnbp from "../../../utilities/TarifPnbp";

Font.register({ family: "Arial", src: srcArial });
Font.register({ family: "Times", src: srcTimes });
Font.register({ family: "Arial-Bold", src: srcArialBold });
Font.register({ family: "TimesBold", src: srcTimesBold });

// Font.register({ family: 'Roboto-Italic', src: srcRobotoItalic })

const styles = StyleSheet.create({
    page: {
        paddingTop: 20,
        paddingBottom: 180,
        paddingHorizontal: 42,
        boxSizing: "border-box",
    },
    headingImg: {
        width: 115,
        height: 100,
    },
    headingTtd: {
        width: 189,
        height: 123,
    },
    table: {
        display: "table",
        width: "auto",
    },
    tableRow: {
        flexDirection: "row",
        flexWrap: "wrap",
    },
    tableCol: {
        borderWidth: 0,
        borderLeftWidth: 0,
        borderTopWidth: 0,
        padding: 1,
    },
    text: {
        fontSize: 10,
        fontFamily: "Times",
    },
    textBold: {
        fontSize: 12,
        fontFamily: "TimesBold",
    },
    footer: {
        position: "absolute",
        paddingHorizontal: 42,
        bottom: 30,
        left: 0,
        right: 0,
        height: 80,
        textAlign: "center",
        // color: "grey",
        fontSize: 9,
        fontFamily: "Times",
    },
});

const CetakKuitansinll = ({ dataDisposisi, datappm }) => {

    let transaksiService = useMemo(() => new TransaksiService(), [])
    let userService = useMemo(() => new UserService(), [])
    // let masterService = useMemo(() => new MasterService(), [])

    const [upt, setUpt] = useState(null)
    // const [dataPnbp, setDataPnbp] = useState(null)
    const [dataPnbpDtl, setDataPnbpDtl] = useState(null)
    const [total, setTotal] = useState(0)

    //   const [uraianUpt, setUraianUpt] = useState(null);
    //   const [alamatUpt, setAlamatUpt] = useState(null);

    //   const [listPenugasanDetil, setListPenugasanDetil] = useState([]);
    const fetchAllData = useCallback(async () => {
        if (!datappm.nomorAju || !dataDisposisi.noTugas) {
            return
        }

        try {
            const results = await Promise.allSettled([
                userService.getUptById(datappm.kodeUpt),
                transaksiService.getPnbpByAjuNoPnbp(datappm.nomorAju, dataDisposisi.noTugas)
            ])

            const [resUpt, resPnbp] = results

            const getData = (res, fallback = []) =>
                res.status === "fulfilled"
                    ? res.value?.data?.data ?? res.value?.data ?? fallback
                    : fallback;
            setUpt(getData(resUpt))
            // setDataPnbp(getData(resPnbp))

            const resPnbpDtl = await transaksiService.listPnbpDetilAll(resPnbp.value?.data?.idPnbp, datappm.nomorAju)
            setDataPnbpDtl(resPnbpDtl.data.data)

            // console.log(resPnbpDtl)

            const total = resPnbpDtl.data.data.reduce((acc, dtl) => acc + dtl.totalTarif, 0)
            // console.log(total)
            setTotal(total)

        } catch (error) {
            console.log(error)
        }
    }, [userService, transaksiService, datappm, dataDisposisi])

    useEffect(() => {
        let isMounted = true;
        if (!datappm) return;

        const loadData = async () => {
            try {
                await fetchAllData();
            } catch (e) {
                if (isMounted) console.error(e);
            }
        };

        loadData();

        return () => { isMounted = false; };
    }, [datappm, fetchAllData]);

    // useEffect(() => {
    //     if (!datappm) return
    //     const fetchAllData = async () => {
    //         try {
    //             const resUpt = await userService.getUptById(datappm.kodeUpt)
    //             // console.log(resUpt)
    //             setUpt(resUpt.data)

    //             const resPnbp = await transaksiService.getPnbpByAjuNoPnbp(datappm.nomorAju, dataDisposisi.noTugas)
    //             // setDataPnbp(resPnbp.data)

    //             const resPnbpDtl = await transaksiService.listPnbpDetilAll(resPnbp.data.idPnbp, datappm.nomorAju)
    //             setDataPnbpDtl(resPnbpDtl.data.data)

    //             const total = resPnbpDtl.data.data.reduce((acc, dtl) => acc + dtl.totalTarif, 0)
    //             setTotal(total)

    //         } catch (error) {
    //             console.log(error)
    //         }
    //     }
    //     fetchAllData()
    // }, [datappm, transaksiService, dataDisposisi, masterService, userService])

    return (
        <Document>
            <Page size="A4" style={styles.page}>
                <View style={[styles.table, { marginBottom: 10, marginTop: 5 }]}>
                    <View
                        style={[styles.tableRow, { borderBottom: 2, borderBottomStyle: "solid" },]}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                            <Text style={[styles.textBold, { fontSize: 18, textAlign: "center" }]}>
                                KEMENTERIAN KELAUTAN DAN PERIKANAN
                            </Text>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "center" }]}>
                                {upt !== null ? getNamaUPTBaru(dataDisposisi.tglTugas, upt) : '-'}
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "100%", alignItems: "center" }]}>
                            <Text style={[styles.textBold, { fontSize: 16, textAlign: "center", borderBottom: 2, borderBottomStyle: "solid", },]}>
                                K W I T A N S I
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                Nomor
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "77%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                {dataDisposisi.noTugas}
                            </Text>
                        </View>
                    </View>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                Sudah Terima Dari
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "77%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                {datappm.namaTrader}
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: "20%" }]}></View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "77%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                {datappm.alamatTrader}
                            </Text>
                        </View>
                    </View>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                Uang Sebanyak
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "77%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                {formatRupiah(total)}
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 10 }]}>
                    <View style={styles.tableRow}>
                        <View style={[styles.tableCol, { width: "100%" }]}>
                            <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>
                                Untuk pembayaran sbb :
                            </Text>
                        </View>
                    </View>
                    {/* <View style={[styles.tableRow]}>
                        <View style={[styles.tableCol, { width: "2%", alignItems: "left" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                -
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "90%", alignItems: "left" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                Sertifikasi Dokumen Kesehatan Ikan dan Mutu Hasil Perikanan
                            </Text>
                        </View>
                    </View> */}
                    {
                        dataPnbpDtl !== null && dataPnbpDtl.map((dtl, index) => {
                            return (
                                <View key={index} style={[styles.tableRow]}>
                                    <View
                                        style={[styles.tableCol, { width: "2%", alignItems: "left" }]}>
                                    </View>
                                    <View style={[styles.tableCol, { width: "36%", alignItems: "left" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>
                                            <TarifPnbp kdTarif={dtl.kodeTarif} param={'nama'} />
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "4%" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>
                                            {dtl.volume}
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "15%" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>
                                            {dtl.satuan}
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "5%" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>
                                            X
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "16%" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "right" }]}>
                                            {<TarifPnbp kdTarif={dtl.kodeTarif} param={'tarif'} />}
                                        </Text>
                                    </View>
                                    <View style={[styles.tableCol, { width: "22%" }]}>
                                        <Text style={[styles.text, { fontSize: 9, textAlign: "right" }]}>
                                            {formatRupiah(dtl.totalTarif)}
                                        </Text>
                                    </View>
                                </View>
                            )
                        })
                    }
                    <View style={[styles.tableRow, { marginTop: 5, marginBottom: 20 }]}>
                        <View style={[styles.tableCol, { width: "80%", alignItems: "left" }]}>
                            <Text style={[styles.textBold, { fontSize: 11, textAlign: "right" }]}>
                                Total Rp.
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.textBold, { fontSize: 11, textAlign: "right" }]}>
                                {formatRupiah(total)}
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={[styles.table, { marginBottom: 5 }]}>
                    <View style={[styles.tableRow, { marginBottom: 5 }]}>
                        <View style={[styles.tableCol, { width: "20%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                Terbilang
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "3%" }]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]}>
                                :
                            </Text>
                        </View>
                        <View style={[styles.tableCol, { width: "77%", borderLeft: 1, borderRight: 1, borderTop: 1, borderBottom: 1, borderBottomStyle: "solid", backgroundColor: "#D1D1D1", },]}>
                            <Text style={[styles.textBold, { fontSize: 12, textAlign: "left" }]} >
                                {numberToWords(total)} Rupiah
                            </Text>
                        </View>
                    </View>
                </View>
                <View style={styles.footer}>
                    <View style={styles.table}>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>No. Pengajuan</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>:</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>{datappm.nomorAju}</Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>{upt !== null ? upt.kota : '-'}, {formatDateStringDateFirst(dataDisposisi.tglTugas)}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}>Bendaharawan Penerima / Kasir</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}> </Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>{dataDisposisi.nmPejabat}</Text>
                            </View>
                        </View>
                        <View style={styles.tableRow}>
                            <View style={[styles.tableCol, { width: "18%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "2%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 12, textAlign: "left" }]}></Text>
                            </View>
                            <View style={[styles.tableCol, { width: "40%" }]}>
                                <Text style={[styles.text, { fontSize: 9, textAlign: "left" }]}>NIP. {dataDisposisi.nipPejabat}</Text>
                            </View>
                        </View>
                    </View>
                </View>
            </Page>
        </Document>
    );
};

export default CetakKuitansinll;
